// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3rX5J","content":"_1SMPo","ad":"_2j4QZ","card":"_1xN84"};